import { Record } from 'immutable';

const defaultValues = {
  recipeCount: null,
  menuCount: null,
  menuItemCount: null,
  designCount: null,
  ingredients: null,
  recipeCategories: null,
  brandId: null,

};

export default class CurrentStats extends Record(defaultValues, CurrentStats) {
  constructor(values) {
    super({
      ...values,
    });
  }
}
